import React from 'react';
import Icon, { GLYPHS } from '../../../common/icon';
import { t } from '../../../../modules/infra/i18n';

const MembershipPaymentWarning = () => (
  <div className="c-payment-type-warning-item">
    <Icon glyph={GLYPHS.exclamationCircle} size="small" />
    <span className="u-pl-">{t('register:payment.membership_warning.card_required')}</span>
  </div>
);

export default MembershipPaymentWarning;
